module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/schedule_04-fdde1bd557c70f347475a3e32b253151.jpg";